import { Button as MuiButton, Stack } from '@mui/material'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import { MapTrifold } from '@phosphor-icons/react'
import MobileEmptyStateCard from '../../../components/MobileEmptyStateCard'
import { MobileExpandableDetailCard } from '../../../components/mobile'
import AppChip from '../../../components/chips/AppChip'
import { getTimestampFromDateTime } from '../../../helpers/formatDate'
import {
  canShowActivityLocation,
  resolveActivityGeofenceLabel
} from '../helpers/activityBreakdownFilters'
import { getGeofenceStatus } from '../helpers/geofenceStatus'
import { VISIT_ACTIVITY_CHIP_VARIANT } from '../helpers/visitChipVariant'
import { formatMoney } from '../../../helpers/utils'
import { REPORT_MOBILE_OUTLINED_ACTION_BUTTON_SX } from './styles/reportMobileActionButtonSx'

export default function ActivityBreakdownMobileContent({
  data = [],
  expandedActivityKey,
  onToggleExpand,
  formatActivityName,
  onCodeClick,
  onOpenLocation
}) {
  if (data.length === 0) {
    return (
      <MobileEmptyStateCard
        icon={<DescriptionOutlinedIcon fontSize="small" />}
        title="No hay actividades registradas"
        description="Cuando existan actividades en el rango seleccionado, aparecerán aquí con su detalle."
      />
    )
  }

  return (
    <Stack spacing={1.5} sx={{ width: '100%', minWidth: 0 }}>
      {data.map((model) => {
        const activityName = formatActivityName(model.activity_name)
        const activityCode = model.activity_uid || model.created_date
        const isErrorActivity =
          model.activity_name.includes('ANULAD') || model.activity_name.includes('RECHAZAD')
        const canShowLocation = canShowActivityLocation(model)
        const locationButton = canShowLocation ? (
          <MuiButton
            variant="outlined"
            size="small"
            fullWidth
            startIcon={<MapTrifold size={18} weight="regular" />}
            type="button"
            onClick={(event) => onOpenLocation(model, event)}
            sx={REPORT_MOBILE_OUTLINED_ACTION_BUTTON_SX}
          >
            Ver ubicación
          </MuiButton>
        ) : null

        return (
          <MobileExpandableDetailCard
            key={activityCode}
            code={`${model.client_uid} - ${model.client_name}`}
            bodyFontSize={14}
            codeFontSize={14}
            summaryValueFontSize={14}
            onCodeClick={(event) => onCodeClick(event, model)}
            expanded={expandedActivityKey === activityCode}
            onToggleExpand={() => onToggleExpand(activityCode)}
            summaryRows={[
              {
                label: 'Fecha y hora',
                value: getTimestampFromDateTime(model.created_date)
              },
              {
                label: 'Actividad',
                value: (
                  <AppChip
                    label={activityName}
                    variant={isErrorActivity ? 'danger' : VISIT_ACTIVITY_CHIP_VARIANT}
                  />
                ),
                alignLabelAndValue: true
              }
            ]}
            detailRows={[
              {
                icon: <DescriptionOutlinedIcon fontSize="small" />,
                label: 'Motivo / descripción',
                value: model.motive_text || '-'
              },
              {
                icon: <PaymentsOutlinedIcon fontSize="small" />,
                label: 'Monto',
                value: model.total != null ? formatMoney(model.total) : '-'
              },
              {
                icon: <PlaceOutlinedIcon fontSize="small" />,
                label: 'Dentro de geocerca',
                value: model.activity_name.includes('LIQUID') ? (
                  '-'
                ) : (
                  <AppChip {...getGeofenceStatus(resolveActivityGeofenceLabel(model))} />
                ),
                fullWidthFooter: locationButton
              }
            ]}
            lighterDetailDividers
          />
        )
      })}
    </Stack>
  )
}
